var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mq-layout',{attrs:{"mq":"lg"}},[_c('nav_desktop')],1),_c('mq-layout',{attrs:{"mq":['sm', 'md']}},[_c('nav_mobile')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }